<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="2" />
    <div class="yj-banner rel">
      <img src="@/assets/images/wz-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/index" class="f16 fw">玩转富林</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">玩转富林</div>
        <div class="f17 ls3">Explore Guangfulin</div>
      </div>
    </div>
    <div class="spot-cont mt-40 pb50">
      <div class="spot-tit df align_center justify_center">
        <h2 class="f32 foo pb15">纪念品展示</h2>
      </div>
      <div class="spot-item df flex_wrap w1200 auto pt20">
        <div class="spot-box wp25" v-for="item in list" :key="item.Id">
          <div class="db rel ml12 mr12 mt24 spot-link">
            <img v-if="item.Photo" :src="item.Photo + '!/both/552x552'" class="db wp100" alt="">
            <div v-if="item.Name" class="spot-box-txt df align_center ">
              <span class="f17 b line_clamp1 mra">{{ item.Name }}</span>
              <span class="f18 fr">{{ item.TrainMode }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pages df align_center justify_center pt50 pb50">
        <!-- <div class="pages-btn df align_center justify_center">
          <img src="@/assets/images/pages-lt.png" class="db" alt="" />
        </div>
        <div class="pages-item df align_center justify_center">
          <router-link to="/" class="pages-box df align_center justify_center">1</router-link>
          <router-link to="/" class="pages-box df align_center justify_center">2</router-link>
          <router-link to="/" class="pages-box df align_center justify_center">3</router-link>
          <router-link to="/" class="pages-box df align_center justify_center">4</router-link>
          <router-link to="/" class="pages-box df align_center justify_center">5</router-link>
          <router-link to="/" class="pages-box df align_center justify_center">6</router-link>
          <router-link to="/" class="pages-box df align_center justify_center">7</router-link>
          <router-link to="/" class="pages-box df align_center justify_center">8</router-link>
        </div>
        <div class="pages-btn df align_center justify_center">
          <img src="@/assets/images/pages-rt.png" class="db" alt="" />
        </div> -->
        
        <el-pagination
          background
          layout="prev, pager, next"
          :total="filter.total"
          :current-page="filter.Page"
          :page-size="filter.PageSize"
          @current-change="handleCurrentPage">
        </el-pagination>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import souvenirService from '@/services/client/cont/line'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      filter: {
        Page: 1,
        PageSize: 12,
        total: 0,
      },
      list: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      this.list = null;
      souvenirService.list(this.filter).then(res => {
        if(res.Code == 200 && res.Data && res.Data.List && res.Data.List.length > 0) {
          this.list = res.Data.List;

          this.filter.total = res.Data.Count;
        }
      })
    },
    handleCurrentPage(page) {
      this.filter.Page = page;
      this.loadData();
    }
  },

}
</script>

<style>
  .spot-link{ background-color: #fff;}
  .spot-box-txt{ padding: 12px 20px;}
</style>


// WEBPACK FOOTER //
// src/views/wanzhuan/jinianpin.vue